import React from 'react';

const Legal = () => {
    return (
        <div id='legal-container'>
            <div className="brand-logo">
                <h1>
                    <span>B</span>k-
                    <span>E</span>lite.
                </h1>
            </div>
            <div className="legal-title">
                <h2>Mentions légales</h2>
                <h3>Bk-Elite-E-Transport</h3>
            </div>
            <div className="legal-txt">
                <p>Auto-entreprise</p>
                <p>Responsable de la publication : Benabdenbi Kamal</p>
                <p>Siret : 94804486200019.</p>
                <p>Ape 4932Z</p>
                <p>Adresse : 08 avenue Albert Camus 30150 Roquemaure</p>
                <p>Téléphone : 06.58.22.86.36</p>
                <p>Le site est hébergé HOSTINGER - UAB Svitrigailos g.34.03228</p>
                <p>Conception et mise en ligne du site internet : Paulet Grégoire</p>
            </div>
        </div>
    );
};

export default Legal;